import { DatePicker, message, Button } from 'antd'
import { getPpr } from 'api/pgads'
import {
  DatePickerContext,
  ErrorContext,
  SpinContext,
  UnitSelectionContext,
} from 'context'
import {
  UnitSelection,
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  getUtilityNameMap,
  getUtilityUnitsMap,
  getValidYearRange,
} from 'core'
import { CriteriaRow, Title } from 'core/screen-util'
import React, { useContext } from 'react'
import { connect } from 'react-redux'
import { downloadFile } from 'reports/dm/reportCall'

const title = 'PPR'

const PPR = ({ apiTargetInfo }) => {
  const { setError } = useContext(ErrorContext)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const { selectedUnits } = useContext(UnitSelectionContext)
  const { setSpinning } = useContext(SpinContext)

  const onExport = () => {
    if (selectedUnits.length <= 0) {
      message.warning('Please select unit')
      return
    }
    setSpinning(true)
    getPpr(apiTargetInfo)(
      selectedDateRangePicker[0],
      selectedDateRangePicker[1],
      selectedUnits
    ).fork(setError, data => {
      setSpinning(false)

      downloadFile(apiTargetInfo)(data.fileName)
    })
  }

  return (
    <div>
      <UnitSelection />
      <CriteriaRow style={{}}>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            marginLeft: '10px',
            minWidth: '100px',
          }}
        >
          {title}
        </Title>
        <DatePicker.RangePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDateRangePicker}
          onChange={d => {
            setSelectedDateRagePicker(d)
          }}
        />

        <Button
          style={{ marginLeft: '10px' }}
          onClick={onExport}
          icon="export"
          type="primary"
        >
          Download
        </Button>
      </CriteriaRow>
    </div>
  )
}

// export default PPR
const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(PPR)
